// ข้อมูลระบบ insight ที่หน้าจออื่นใช้ร่วมกัน — ทุก hook ไม่ทำอะไรเลยถ้าผู้ใช้ไม่ได้เปิดใช้ (server ตัดสินผ่าน /api/insight/me)
import { useQuery } from '@tanstack/react-query';
import api from '../../adapters/api';

export function useInsightMe() {
  return useQuery({
    queryKey: ['insightMe'],
    queryFn: async () => (await api.get('/api/insight/me')).data,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

function useInlineEnabled() {
  const { data } = useInsightMe();
  return Boolean(data?.channels?.inline);
}

// { [doc_no]: { tone, label } } ของ SO ค้างที่ผู้ใช้มองเห็น
export function useInlineOrders() {
  const enabled = useInlineEnabled();
  const { data } = useQuery({
    queryKey: ['insightInlineOrders'],
    queryFn: async () => (await api.get('/api/insight/inline/orders')).data,
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return enabled && data?.enabled ? data.docs : null;
}

// { [item_code]: { daysLeft, perDay, net, accruedIn, unit } } สินค้าที่คาดว่าจะหมดใน ≤ 7 วัน
export function useInlineItems() {
  const enabled = useInlineEnabled();
  const { data } = useQuery({
    queryKey: ['insightInlineItems'],
    queryFn: async () => (await api.get('/api/insight/inline/items')).data,
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return enabled && data?.enabled ? data.items : null;
}

// การ์ดลูกค้า: { buy: { p, base, lastDate, everyDays, typicalAmount }, drop: { current, normal, change } } | null
export function useInlineCustomer(custCode) {
  const enabled = useInlineEnabled();
  const code = String(custCode || '').trim();
  const { data } = useQuery({
    queryKey: ['insightInlineCustomer', code],
    queryFn: async () => (await api.get(`/api/insight/inline/customer/${encodeURIComponent(code)}`)).data,
    enabled: enabled && Boolean(code),
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
  return enabled && data?.enabled ? data.card : null;
}
